import { Inject, Injectable, Optional } from '@angular/core';
import {
  DashboardCardService,
  DashboardCard,
  InactiveCustomersCardComponent,
  FilterCardLargeComponent,
  ActiveProductsCardComponent,
  SalesSummaryCardComponent,
  CustomersWhoPurchasedCardComponent,
  MonthlySalesAmountSummaryCardComponent,
  MonthlySalesSummaryCardComponent
} from 'gung-dashboard';
import { AuthService, NavigationConfig } from 'gung-standard';
import { RefCustomersOrderedFiveMonthsComponent } from '../../components/dashboard/ref-customers-ordered-five-months/ref-customers-ordered-five-months.component';
import { RefCustomersOrderedTwoMonthsComponent } from '../../components/dashboard/ref-customers-ordered-two-months/ref-customers-ordered-two-months.component';

@Injectable({
  providedIn: 'root'
})
export class RefDashboardCardService extends DashboardCardService {
  constructor(
    protected authService: AuthService,
    @Optional()
    @Inject('environment')
    protected environment: NavigationConfig
  ) {
    super(
      authService,
      environment
    );
    super.clearCards();

    super.addCard(new DashboardCard(MonthlySalesSummaryCardComponent, 'col-xs-12 col-md-6 col-xl-3'));
    super.addCard(new DashboardCard(MonthlySalesAmountSummaryCardComponent, 'col-xs-12 col-md-6 col-xl-3'));
    super.addCard(new DashboardCard(CustomersWhoPurchasedCardComponent, 'col-xs-12 col-md-6 col-xl-3'));
    super.addCard(new DashboardCard(ActiveProductsCardComponent, 'col-xs-12 col-md-6 col-xl-3'));
    super.addCard(new DashboardCard(FilterCardLargeComponent, 'col-xs-12 col-md-12 col-xl-12'));
    super.addCard(new DashboardCard(InactiveCustomersCardComponent, 'col-xs-12 col-md-12 col-xl-12'));
  }
}
